<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { Icon } from '@shared/ui/icon';
  import { is } from '@shared/lib/utils';
  import type { ToggleButtonItem } from '@shared/lib/stores/layouts';

  const dispatcher = createEventDispatcher();
  export let toggleList: ToggleButtonItem[];

  export let value: string | undefined = undefined;

  export let isConsistent = false;

  const handleClick = (item, index) => {
    if (!isConsistent) {
      dispatcher('change', item);
    } else {
      dispatcher('change', getNextVal(index, toggleList));
    }
  };

  const getNextVal = (i, arr) => arr.at((i + 1) % arr.length).value;
</script>

<div class="relative flex flex-nowrap gap-4">
  {#each toggleList as toggle, index}
    <button
      class="
        opacity-1
        hover:text-default-500 inline-block
        w-auto
        transition-all
        dark:hover:text-white
        {toggle.value === value ? 'text-neutral-900 dark:text-white' : 'text-default-400 dark:text-dark-400'}
        {is(
        isConsistent && toggle.value !== value,
        'pointer-events-none collapse absolute left-0 top-0 opacity-0 duration-300',
      )}"
      type="button"
      value="center"
      on:click="{() => handleClick(toggle.value, index)}"
    >
      <Icon name="{toggle.icon}" focusable="false" />
    </button>
  {/each}
</div>
